import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';


type State = {
  headerAndFooterData: any,
  categoryList: any[],
  areaKey: string,
  selectedCategory: string 
}

const initialState: State = {
  headerAndFooterData: {},
  categoryList: [],
  areaKey: 'https://www.fwd.com.hk/en/',
  selectedCategory: ''
};

const NAME = 'headerAndFooter';
export const headerAndFooterSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    changeHeaderFooter: (state, action) => {
      state.headerAndFooterData = action.payload;
    },
    changeCategoryList: (state, action) => {
      state.categoryList = action.payload;
    },
    changeArea: (state, action) => {
      state.areaKey = action.payload;
    },
    changeSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => ({
      ...state,
      ...action.payload[NAME]
    }))
  },
});

export const {
  changeHeaderFooter,
  changeCategoryList,
  changeArea,
  changeSelectedCategory
} = headerAndFooterSlice.actions;
export default headerAndFooterSlice;
